import React from 'react';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { capitalizeAllWords } from '../textHelper';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
import _get from 'lodash/get';
import _trim from 'lodash/trim';
import _some from 'lodash/some';
import _isNil from 'lodash/isNil';

// const styles = theme => ({
// });

const defaultStyle = { width: '100%', padding: 0, margin: 0 };
const defaultFilter = createFilterOptions({
    matchFrom: 'start',
    // limit: 6
});

const filterOptionsCapitalized = (value, options, params) => {
    const inputValue = _get(params, 'inputValue');
    const inputValueCapitalized = capitalizeAllWords(inputValue);
    let filteredOptions = defaultFilter(options, params);
    const isNew = !_some(filteredOptions, option => option.name === _trim(inputValueCapitalized));

    // if option selected, check if inputValue is new or already selected
    const isAdded = !_isNil(value) && value?.inputValue === _trim(inputValueCapitalized);

    // Suggest the creation of a new value
    if (isNew && !isAdded) {
        filteredOptions.push({
            inputValue: inputValueCapitalized,
            name: inputValueCapitalized,
            label: `Add "${inputValueCapitalized}"`,
        });
    }

    return filteredOptions;
};

const getOptionLabel = option => {
    // Add "xxx" option created dynamically: object {inputValue, label}
    if (option?.inputValue) {
        return option.inputValue;
    }
    // Regular option (string) or value selected with enter, right from the input
    return typeof option === 'string' ? option : option.name;
};

const renderOption = option => {
    // Add "xxx" option created dynamically: object {inputValue, label}
    if (option?.inputValue) {
        return option.label;
    }
    // Regular option (string) or value selected with enter, right from the input
    return typeof option === 'string' ? option : option.name;
};

const getOptionSelected = (option, value) => (typeof value === 'string' ? option.name === value : option.name === value?.name);

const AfitdCityAutocomplete = props => {
    const { style = defaultStyle, isCapitalize, value, ...otherProps } = props;

    const filterOptions = filterOptionsCapitalized.bind(null, value);

    return (
        <AfitdAutocompleteLite
            style={style}
            value={value}
            {...otherProps}
            filterOptions={filterOptions}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            getOptionSelected={getOptionSelected}
        />
    );
};

export default AfitdCityAutocomplete;
// export default withStyles(styles)(AfitdCityAutocomplete);
